import getFromCdn from '@anm/helpers/getFromCdn';
import isMobile from '@anm/helpers/is/isMobile';
import { MediaObject } from '@anm/hosting-player';

import { PlayerConfig, PlayerControls, PlayerMappedControls, SupportedQualities } from '../../types';

const isDev = process.env.TS_ENV === 'dev';

export const defaultPlaybarControls: PlayerControls[] = [
  'play',
  'progress',
  'current-time',
  'download',
  'mute',
  'settings',
  'fullscreen',
  'volume',
  'play-large'
];

export const controlsSelectorMap: { [key in PlayerMappedControls]: string } = {
  play: '[data-plyr="play"]:not(.plyr__control--overlaid)',
  progress: '.plyr__progress__container',
  'play-large': '.plyr__control--overlaid',
  volume: '.plyr__volume',
  settings: '.plyr__menu',
  'current-time': '.plyr__time--current',
  'settings-speed': '[role="menu"] button:last-of-type',
  'settings-quality': '[role="menu"] button:first-of-type',
  fullscreen: '[data-plyr="fullscreen"]',
  'playbar-button': '.plyr__controls',
  logo: '.wave-logo',
  download: '.plyr__control[data-plyr="download"]'
};

export const qualityOptions: SupportedQualities[] = [240, 360, 480, 576, 720, 1080, 1440, 2160, 2880, 4320];

export const getIconUrl = () => {
  const iconsPath = `images/player-icons_v4.svg`;
  return isDev ? `https://assets.animatron-test.com/static/${iconsPath}` : getFromCdn(`${iconsPath}`);
};

const getPlayerConfigs = (sources?: MediaObject[]): PlayerConfig => {
  const clickToPlay = !isMobile() && !!sources?.length;

  return {
    clickToPlay,
    debug: false,
    quality: {
      default: 720,
      options: qualityOptions
    },
    storage: { enabled: false },
    settings: ['quality', 'speed'],
    invertTime: false,
    iconUrl: getIconUrl(),
    fullscreen: { enabled: true, fallback: true, iosNative: true },
    hideControls: true,
    disableContextMenu: !isDev
  };
};

export default getPlayerConfigs;
